import { ProyectosPlataformaService } from "../../../shared/generated/grpc/plataforma_proyectos_pb";
import { ServiceDeleteBase } from "../../../shared/services/base/ServiceDeleteBase";
import { grpcCall, grpcClient } from "../../../shared/services/grpc/grpcCall";
import { CatalogoService } from "./CatalogoService";

/** Baja de un ítem del catálogo maestro; lo saca de la lista de su cultivo. */
export class CatalogoItemDeleteService extends ServiceDeleteBase {
  protected readonly cache = CatalogoService.instance;

  /** gRPC-Web (`EliminarCatalogoItem`): baja lógica. Falla si algún proyecto usa el ítem. */
  protected async sendDelete(id: string): Promise<void> {
    await grpcCall(() => grpcClient(ProyectosPlataformaService).eliminarCatalogoItem({ id }));
  }
}
